import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';
import { CalculationUsageTC, ReportTypeTC } from '../../business/models/typecode.enums';

import { DaccaCalculation } from '../../store/details/dacca/types';
import { Dispatch } from 'redux';
import {RimLinesRequest as RimLine } from '../../business/models/dto/rim/rim-lines.request.dto';
import { RingLoader } from 'react-spinners';
import { SvsDTOLine as SvsLine } from '../../business/models/dto/svs/svs.dto';
import { connect } from 'react-redux';
import { importLinesFromDacca } from '../../store/details/dacca/actions';
import { Company } from '../../store/shared/model';

const styles = {
  daccaImportButton: {
    display: 'flex',
    justifyContent: 'center',
    padding: '5px',
    marginLeft: 'auto',
    marginBottom: 'auto',
    width: '100px',
    cursor: 'pointer'
  },
  overlay: {
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: '20px',
      marginLeft: 'auto',
      marginBottom: 'auto',
      width: '100px',
      cursor: 'progress'
    }
};

interface DaccaImportButtonProps {
  readonly reportType: string;
  readonly reference: number;
}

interface PropsFromState {
  readonly daccaCalculations: DaccaCalculation[];
  readonly rimLines: RimLine[];
  readonly svsLines: SvsLine[];
  readonly loading: boolean;
  readonly parentPartyDibCode: string;
  readonly caseCode: string;
}

interface PropsFromDispatch {
  readonly importLinesFromDacca: typeof importLinesFromDacca;
}

type AllProps = DaccaImportButtonProps & PropsFromDispatch & PropsFromState & ConnectedReduxProps;

class DaccaImportButton extends React.Component<AllProps> {
  render() {

    const isBelfiusParentCompany = this.props.parentPartyDibCode === Company.Belfius;

    const calculationExists = this.props.reportType === ReportTypeTC.Rim
      ? this.props.daccaCalculations.filter(p => p.calculationUsageTC === CalculationUsageTC.Fin || p.calculationUsageTC === CalculationUsageTC.Diy).length > 0
      : this.props.daccaCalculations.filter(p => p.calculationUsageTC === CalculationUsageTC.Rik).length > 0;

    const isAlreadyImported = this.props.reportType === ReportTypeTC.Rim
      ? this.props.rimLines.filter(p => p.isImportFromDacca && !p.deleted).length > 0
      : this.props.svsLines.filter(p => p.isImportFromDacca && !p.deleted).length > 0;

    const daccaImportButtonImagePath = isAlreadyImported
      ? require('../../assets/images/retrieve_dacca_green_85x85.png')
      : require('../../assets/images/retrieve_dacca_85x85.png');

    const cssStyleRingLoader: React.CSSProperties = {
      color: '#223146',
      margin: '20px'
    }
    return (
      (isBelfiusParentCompany ?
      <div>
        {calculationExists && !this.props.loading
          ? <div style={styles.daccaImportButton}
            onClick={() => { this.props.importLinesFromDacca(this.props.reportType, this.props.caseCode, this.props.reference); }} >
            <img alt="" src={daccaImportButtonImagePath} />
          </div>
          : ''}
          {this.props.loading
            ? <div style={styles.overlay}><RingLoader cssOverride={cssStyleRingLoader} size={40} loading={this.props.loading} /></div>
            : ''
          }
      </div> : '' )
    );
  }
}

const mapStateToProps = ({ details, shared, caseState: { selectedCase } }: ApplicationState) => ({
  daccaCalculations: details.detailsDacca.daccaCalculations,
  rimLines: details.detailsRim.rimLines,
  svsLines: details.detailsSvs.lines,
  loading: details.detailsDacca.loading,
  parentPartyDibCode: shared.parentPartyDibCode,
  caseCode: selectedCase.caseCode,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  importLinesFromDacca: (reportType: string, caseCode: string, reference: number) => dispatch(importLinesFromDacca(reportType, caseCode, reference))
});

export default connect(mapStateToProps, mapDispatchToProps)(DaccaImportButton);
